import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import {Badge, Button, Col, Form, FormGroup, Label, Row} from "reactstrap";
import Select from "react-select";
import {bulkAddProductTags, bulkRemoveProductTags} from "../../../store/prodcutSlice";
import {useDispatch} from "react-redux";
import {Plus, Tag, X} from "react-feather";
import ButtonLoader from "../../../../../share-components/ui/buttonLoader";

const defaultValues = {
    tag: [],
    is_add_tag: 1,
};

function ProductTagsBulk(props) {
    const {state, closeDialog, selectedProductId, setSelectedProductId, productFilter, setSelectedPage} = props;
    const dispatch = useDispatch();
    const [buttonDisable, setButtonDisable] = useState(false);
    const [localSelectedProductId] = useState(selectedProductId);
    const {handleSubmit, setValue, watch} = useForm({
        mode: 'onChange',
        defaultValues,
    });

    const isAddTag = watch('is_add_tag');
    const selectedTags = watch('tag') || [];

    const onSubmit = (data) => {
        const payload = {
            product_ids: localSelectedProductId,
            tag_ids: data.tag.map(t => t.id),
        };
        setButtonDisable(true);
        const action = data.is_add_tag === 1 ? bulkAddProductTags : bulkRemoveProductTags;
        dispatch(action(payload)).then(() => {
            productFilter();
            setSelectedProductId([]);
            setSelectedPage([]);
            setButtonDisable(false);
            closeDialog();
        }).catch(() => {
            setButtonDisable(false);
        });
    };

    const isAdd = isAddTag === 1;

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>

            {/* Product count banner */}
            <div style={{
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: 6,
                padding: '10px 14px',
                marginBottom: 18,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
            }}>
                <Tag size={15} color="#6c757d"/>
                <span style={{fontSize: 13, color: '#495057'}}>
                    Applying to&nbsp;
                    <strong>{localSelectedProductId.length}</strong>
                    &nbsp;product{localSelectedProductId.length !== 1 ? 's' : ''}
                </span>
            </div>

            {/* Action toggle */}
            <FormGroup>
                <Label className="col-form-label pb-1">Action</Label>
                <div style={{display: 'flex', gap: 8}}>
                    <button
                        type="button"
                        onClick={() => setValue('is_add_tag', 1)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            padding: '7px 18px',
                            borderRadius: 6,
                            border: isAdd ? '2px solid #28a745' : '2px solid #dee2e6',
                            background: isAdd ? '#e8f5e9' : '#fff',
                            color: isAdd ? '#1b5e20' : '#6c757d',
                            fontWeight: isAdd ? 600 : 400,
                            cursor: 'pointer',
                            fontSize: 13,
                            transition: 'all 0.15s',
                        }}
                    >
                        <Plus size={14}/>
                        Add Tags
                    </button>
                    <button
                        type="button"
                        onClick={() => setValue('is_add_tag', 0)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            padding: '7px 18px',
                            borderRadius: 6,
                            border: !isAdd ? '2px solid #dc3545' : '2px solid #dee2e6',
                            background: !isAdd ? '#fdecea' : '#fff',
                            color: !isAdd ? '#7f0000' : '#6c757d',
                            fontWeight: !isAdd ? 600 : 400,
                            cursor: 'pointer',
                            fontSize: 13,
                            transition: 'all 0.15s',
                        }}
                    >
                        <X size={14}/>
                        Remove Tags
                    </button>
                </div>
            </FormGroup>

            <hr style={{margin: '14px 0'}}/>

            {/* Tag selector */}
            <FormGroup>
                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6}}>
                    <Label className="col-form-label mb-0">Tags</Label>
                    {selectedTags.length > 0 && (
                        <Badge
                            color={isAdd ? 'success' : 'danger'}
                            pill
                            style={{fontSize: 11}}
                        >
                            {selectedTags.length} selected
                        </Badge>
                    )}
                </div>
                <Select
                    isMulti
                    placeholder="Search and select tags..."
                    getOptionLabel={option => option.name}
                    getOptionValue={option => option.id}
                    onChange={e => setValue('tag', e || [])}
                    options={state.productIndexSettings?.tags || []}
                    menuPortalTarget={document.body}
                    isClearable
                    components={{IndicatorSeparator: () => null}}
                    styles={{
                        menuPortal: base => ({...base, zIndex: 100000}),
                        multiValue: base => ({
                            ...base,
                            background: isAdd ? '#e8f5e9' : '#fdecea',
                            borderRadius: 4,
                        }),
                        multiValueLabel: base => ({
                            ...base,
                            color: isAdd ? '#1b5e20' : '#7f0000',
                            fontWeight: 500,
                        }),
                        multiValueRemove: base => ({
                            ...base,
                            color: isAdd ? '#388e3c' : '#c62828',
                            ':hover': {
                                background: isAdd ? '#c8e6c9' : '#ffcdd2',
                            },
                        }),
                    }}
                />
                {selectedTags.length > 0 && (
                    <div style={{
                        marginTop: 8,
                        fontSize: 12,
                        color: isAdd ? '#388e3c' : '#c62828',
                    }}>
                        {isAdd
                            ? `${selectedTags.length} tag${selectedTags.length !== 1 ? 's' : ''} will be added to ${localSelectedProductId.length} product${localSelectedProductId.length !== 1 ? 's' : ''}`
                            : `${selectedTags.length} tag${selectedTags.length !== 1 ? 's' : ''} will be removed from ${localSelectedProductId.length} product${localSelectedProductId.length !== 1 ? 's' : ''}`
                        }
                    </div>
                )}
            </FormGroup>

            {/* Footer */}
            <Row style={{marginTop: 8}}>
                <Col sm={12}>
                    <div className="float-right">
                        <Button
                            className="ml-3"
                            color="secondary"
                            type="button"
                            onClick={closeDialog}
                        >
                            Cancel
                        </Button>
                        <ButtonLoader
                            style={{marginLeft: 10, width: 'auto'}}
                            disabled={buttonDisable || selectedTags.length === 0}
                            color={isAdd ? 'success' : 'danger'}
                            type="submit"
                            btntext={isAdd ? 'Add Tags' : 'Remove Tags'}
                        />
                    </div>
                </Col>
            </Row>
        </Form>
    );
}

export default ProductTagsBulk;
